module.exports = __webpack_public_path__ + "img/two_3.c1001209.png";